import db from "./db";
export { applicationIdCache, applicationIdToOrganizationIdCache } from "./cache";
export * from "./application";
export * from "./applicationUserAttributeMapping";
export * from "./applicationUserEvents";
export * from "./authz";
export * from "./cache";
export * from "./db";
export * from "./organization";
export * from "./paywall";
export * from "./paywallAsset";
export * from "./project";
export * from "./seeds";
export * from "./shortLink";
export * from "./survey";
export * from "./triggerExperiment";
export * from "./types";
export * from "./user";
export * from "./webPaywall";
export * from "./webProduct";
export * from "./db";
export default db /**
 * Disabled query logging.
 *
 * This logging is very noisy but was useful in debugging issues previously. We're going to
 * kill this for now but we may bring this back in the future.
 *
 *
db.$on("query", (e: QueryEvent) => {
  const { query, duration } = e
  logger.info({ query, duration }, "query")
})

db.$use(async (params, next) => {
  const before = Date.now()
  const result = await next(params)

  let arrayResult = false
  let arrayLength = 0
  if (Array.isArray(result)) {
    arrayResult = true
    arrayLength = result.length
  }
  const after = Date.now()

  const { model, action, dataPath, args } = params
  const duration = after - before
  logger.info({ model, action, duration, dataPath, args, arrayResult, arrayLength }, "prisma_query")
  return result
})
 */ ;
